<template>
  <div class="h-description-item" :style="colStyles">
    <div v-if="labelWrap" :class="labelComputeClass" :style="labelStyles">
      {{ label }}
    </div>
    <div v-else :class="labelComputeClass" :style="labelStyles" :title="label">
      {{ label }}
    </div>
    <div v-if="contextWrap" :class="contextComputeClass" :style="contextStyles">
      <slot></slot>
    </div>
    <div v-else :class="contextComputeClass" :style="contextStyles">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "HDescriptionItem",
  inject: ["column"],
  props: {
    label: {
      type: String,
      default: "-",
    },
    span: {
      type: Number,
      default: 1,
    },
    verticalAlign: {
      type: String,
      default: "center", // start, center
    },
    labelWidth: {
      type: Number,
      default: 80,
    },
    labelPosition: {
      type: String,
      default: "right",
    },
    labelWrap: {
      type: Boolean,
      default: true,
    },
    contextWrap: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      titleContext: "",
    };
  },
  computed: {
    labelComputeClass() {
      return [
        "h-description-item-label",
        this.labelWrap ? "label-wrap" : "label-ellipsis",
      ];
    },
    labelStyles() {
      return {
        width: this.labelWidth + "px",
        "text-align": this.labelPosition,
      };
    },
    contextComputeClass() {
      return [
        "h-description-item-context",
        this.contextWrap ? "context-wrap" : "context-ellipsis",
      ];
    },
    contextStyles() {
      return {
        width: `calc(100% - ${this.labelWidth}px)`,
      };
    },
    colSpan: function () {
      return (this.span * 24) / this.column;
    },
    colStyles: function () {
      return {
        "align-items": this.verticalAlign === "start" ? "baseline" : "center",
        width: ((this.span * 100) / this.column).toFixed(8) + "%",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.h-description-item {
  display: inline-flex;
  padding: 4px 0;
  transition: width 0.2s ease-in-out;
  float: left;
  flex: 0 0 auto;
  .h-description-item-label {
    font-size: 12px;
    color: #333;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    float: left;
    line-height: 28px;
    &:after {
      content: ":";
      margin-left: 2px;
    }
    &.label-wrap {
      word-break: break-all;
    }
    &.label-ellipsis {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 3px;
      &:after {
        position: absolute;
        right: 0;
      }
    }
  }
  .h-description-item-context {
    vertical-align: center;
    font-size: 14px;
    color: #666;
    box-sizing: border-box;
    padding-left: 12px;
    padding-right: 5px;
    &.context-wrap {
      word-break: break-all;
    }
    &.context-ellipsis {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/gtn/components/HDescription/HDescriptionItem.vue